import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import moment from 'moment'
import SiteResourcesSearchForm from './SiteResourcesSearchForm'
import CursorPagination from '../../../../../../components/cursor-pagination'

export default function SiteResourcesDisplay ({ siteResources, siteName, allResources, handleSubmit, handleRemoveResourceFromSite, fakeCount, onPageRequest }) {
  return (
    <div className='row'>
      <ul className='list-group'>
        <li className='list-group-item thumbster-gray-super-light-bg'>
          <h5>
            Current Assets on Site
            <Link to={`/assets?relatedType=SITE_NAME&relatedSearch=${siteName}`}>
              &nbsp;<small className='text-primary link'>(View All)</small>
            </Link>
            <span className='pull-right badge'>{siteResources?.totalCount}</span>
          </h5>
        </li>
        {siteResources?.nodes?.map((resource) => (
          <li key={resource.id} className='list-group-item'>
            <Link to={`/hauler/resources/${resource.id}`}>
              {resource.uid} ({resource?.resourceType?.name || 'UNKNOWN'})
            </Link>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <i
              className='pull-right material-icons cursor-pointer'
              onClick={() => handleRemoveResourceFromSite(resource.id)}>
              delete
            </i>
            <em className='opacity-5 pull-right'>
              Marked:&nbsp;
              {(() => {
                if (resource.lastMoved) {
                  const parsedMoment = moment(resource.lastMoved)
                  const formattedDate = parsedMoment.format('MMM D, YYYY, h:mm a')
                  const formattedDayCount = parsedMoment.fromNow()
                  return (
                    <span>
                      <strong>
                        {formattedDayCount}
                      </strong>
                      &nbsp;at {formattedDate}
                    </span>
                  )
                }
                return 'N/A'
              })()}
              &nbsp;
              &nbsp;
            </em>
            <div className='clearfix' />
          </li>
        ))}
        {
          siteResources?.totalCount > 0 && <CursorPagination
            pageInfo={siteResources?.pageInfo}
            totalCount={siteResources?.totalCount}
            onPageRequest={onPageRequest}
            fakeCount={fakeCount}
            isSiteJobResourceDisplay
                                           />
        }
        <li className='list-group-item' style={{ borderTop: '0px' }}>
          <SiteResourcesSearchForm
            resources={allResources}
            handleSubmit={handleSubmit}
          />
        </li>
      </ul>
    </div>
  )
}

SiteResourcesDisplay.propTypes = {
  allResources: PropTypes.array.isRequired,
  fakeCount: PropTypes.shape({
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired
  }),
  handleRemoveResourceFromSite: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onPageRequest: PropTypes.func.isRequired,
  siteName: PropTypes.string.isRequired,
  siteResources: PropTypes.shape({
    pageInfo: PropTypes.object,
    nodes: PropTypes.array,
    totalCount: PropTypes.number
  }).isRequired
}
